<form [formGroup]="editVillageForm" (ngSubmit)="onVillageSubmit()" class="needs-validation mt-1 form-row">
    <div class="col">
        <div class="form-group" [formGroup]="editVillageForm">
            <label class="control-label col-form-label-sm">Name</label>
            <div class="input-group input-group-sm">
                <input type="text" class="form-control {{editErrorArray['name'] ? 'is-invalid' : ''}}" placeholder="Village Name" name="name" id="name" [required]="true" formControlName="name" />
                <div class="invalid-feedback">
                    {{editErrorArray['name'] | translate}}
                </div>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="form-group" [formGroup]="editVillageForm">
            <label class="control-label col-form-label-sm">Province</label>
            <select class="form-control form-control-sm {{editErrorArray['provinceId'] ? 'is-invalid' : ''}}" name="provinceId" id="provinceId" [required]="true" formControlName="provinceId">
              <option *ngFor="let province of provincesOptions" value="{{province.value}}">{{province.label}}
                </option>
            </select>
            <div class="invalid-feedback">
                {{editErrorArray['provinceId'] | translate}}
            </div>
        </div>
    </div>
    <div class="col-auto text-right">
        <div class="btn-group btn-group-sm" role="group">
            <button type="submit" class="btn btn-primary btn-sm" style="margin-top: 27px;" title="Update"><i class="fa fa-check"></i></button>
            <button type="button" class="btn btn-danger btn-sm" style="margin-top: 27px;" (click)="cancelEditButtonClick()" title="Cancel"><i class="fa fa-times"></i></button>
        </div>
    </div>
</form>
